<div class="container-alert">
    <div class="header">
        <h1>{{ 'menu.warehouses' | translate}}</h1>
        <p>{{ 'label.allocatePlantMessage' | translate }}</p>
    </div>
    <div class="body">
        <form class="example-form">
            <mat-form-field class="example-full-width" appearance="outline">
            <mat-icon matPrefix><em class="far fa-inventory"></em></mat-icon>
              <mat-label class="almacen-label">{{ 'label.store' | translate }}</mat-label>
              <input tabIndex="-1" class="inputPlant" type="text"
                     [placeholder]="'label.storageNumber' | translate"
                     aria-label="Number"
                     matInput
                     [formControl]="myControl"
                     [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let i of filteredOptions | async" [value]="i">
                  {{i}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </form>
          <p *ngIf="error" class="advert">{{ 'error.warehouseSelected' | translate}}</p>
          <div class="text-right">
              <button (click)="add()" class="styleButton saveButton add" mat-raised-button  disabled="false">
                <mat-icon><em class="fa fa-plus"></em></mat-icon>
                {{ 'button.append' | translate}}
            </button>
          </div>
          <ng-container *ngIf="selectedPlants.length > 0">
              <div class="table-container">
                  <table mat-table [dataSource]="selectedPlants" class="mat-elevation-z8" #myTable>
                    
                    <ng-container matColumnDef="code">
                      <th mat-header-cell *matHeaderCellDef>{{ 'label.code' | translate}}</th>
                      <td mat-cell *matCellDef="let element"> {{element.code}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef>{{ 'label.name' | translate}}</th>
                      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="society">
                      <th mat-header-cell *matHeaderCellDef>{{ 'label.society' | translate}}</th>
                      <td mat-cell *matCellDef="let element"> {{element.society}} </td>
                    </ng-container>
              
                      <ng-container matColumnDef="opcion">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element; let i = index">
                              <button (click)="delete(i)">
                                  <mat-icon color="warn">
                                      <em class="fa fa-times"></em>
                                  </mat-icon>
                              </button>
                          </td>
                        </ng-container>
                          
                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
              </div>
            </ng-container>
    </div>
    <div class="footer">
        <div class="md-margin">
            <app-button (click)="asign()" [disabled]="selectedPlants.length == 0" color="greenButton" disabled="false" icon="far fa-check"
                      [title]="'label.allocatePlant' | translate"></app-button>
        </div>
    </div>
</div>
    
